import React from "react"
import "./css/Showcase.min.css"

const Description = ({title=""}) => (
  <div className="text-center showcase-description">
    <h1>{title || 'Showcase'}</h1>
    <p>
      We are proud to showcase our clients' web design and development projects.
      <br />
      We are constantly looking out for and exploring new designs customised for
      our clients.
    </p>
  </div>
)

export default Description
